import { render, staticRenderFns } from "./CustomerInfoForm.vue?vue&type=template&id=febf50a4&scoped=true&"
import script from "./CustomerInfoForm.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoForm.vue?vue&type=style&index=0&id=febf50a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febf50a4",
  null
  
)

export default component.exports